import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <rect
        width="176"
        height="128"
        x="40"
        y="88"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        rx="8"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M92 88V52a36 36 0 0172 0v36"
      />
      <circle cx="128" cy="152" r="12" />
    </svg>
  );
}

export default Icon;
